import React from 'react';
import BlockCheckoutBuyMore from './BlockCheckoutBuyMore';
import BlockCheckoutBuyMoreSettings from './Settings/BlockCheckoutBuyMoreSettings';

/**
 * Return an array with the opts (option buttons when hovering) to show for this block.
 *
 * @param {useModal} modal 				        The useModal instance used to open and show this block's settings.
 * @param {function} changed 				    The function used to notify Builder when this block changes.
 * @param {function} removeBlock			    A function used to notify Builder to remove this block.
 * @param {useFormValidation} formValidation 	The useFormValidation instance used to validate this modals settings inputs.
 */
const generateOpts = (
	openModal,
	closeModal,
	changed,
	removeBlock,
	formValidation
) => {
	return [
		{
			icon: ['fal', 'gear'],
			action: (blockData) => {
				/**
				 * Open a modal with the settings when pressing the COG icon.
				 */
				const modalActions = [
					{
						text: 'Avbryt',
						isDefault: true,
						action: (originalState, currentState, closeModal) => {
							// Reset builder block settings
							changed(blockData);
							closeModal();
						}
					},
					{
						text: 'Klar',
						action: (originalState, currentState, closeModal) => {
							// Notify builder to update all block's atributes before closing the modal
							changed(currentState);
							closeModal();
						}
					}
				];

				openModal({
					title: 'Redigerar block, Lägg till extra',
					actions: modalActions,
					position: 'right',
					hideBackdrop: true,
					isPositionable: true,
					state: blockData
				});
			}
		},
		{
			icon: ['fal', 'trash'],
			action: (blockData) => {
				// Tell the builder to remove the block
				removeBlock(blockData);
				closeModal();
			}
		}
	];
};

const defaultStruct = {
	// can be added in builder by the user?
	isAddable: true,
	baseStruct: {
		// Used by Builder.
		key: null,
		data: {
			articles: [],
			title: '<p></p>'
		}
	},
	builder: {
		component: <BlockCheckoutBuyMore />,
		setOpts: generateOpts
	},
	settings: {
		component: <BlockCheckoutBuyMoreSettings />
	}
};

export default defaultStruct;
